import { useQuery } from 'react-query';
import { getOrders } from '../api/getOrders';

const useOrders = () => {
  const { data, isLoading, refetch } = useQuery('orders', () => getOrders(), {
    //query options
    refetchOnWindowFocus: true,
    staleTime: 50000,
  });
  return { data, isLoading, refetch };
};

export default useOrders;
